import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Tabs, Typography, Card } from 'antd';
import Params from './params/Params';
import { ReportBigBox } from '../../../../../common/ui/Common';
import Survey from './Elements/Survey/Survey';
import Appeals from './Elements/Appeals/Appeals';
// import ConsolidatedReport from './Elements/ConsolidatedReport/ConsolidatedReport';
import DetailedReport from './Elements/DetailedReport/DetailedReport';
import DetailedReportNew from './Elements/DetailedReportNew/DetailedReportNew';
import NpsReport from './Elements/Nps/NpsReport';

function QualityControl(props) {
  const { preloader } = props;
  const [activeSection, setActiveSection] = useState('appeals');
  const [isMobile, setIsMobile] = useState(false);
  const [settings, setSettings] = useState({
    startDate: moment().startOf('month').format('DD.MM.YYYY HH:mm'),
    endDate: moment().endOf('day').format('DD.MM.YYYY HH:mm'),
    questId: '',
  });

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1350);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <ReportBigBox>
      <Typography.Title style={{ textAlign: 'center', color: '#25547A' }}>Оценочные опросы</Typography.Title>

      <Params
        activeSection={activeSection}
        params={{ settings, setSettings }}
      />

      <Tabs
        activeKey={activeSection}
        onChange={setActiveSection}
      >
        <Tabs.TabPane tab="Обращения" key="appeals">
          <Card style={{ margin: isMobile ? '0 0' : '0' }}>
            <Appeals
              settings={settings}
              preloader={preloader}
            />
          </Card>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Опросы" key="survey">
          <Card style={{ margin: isMobile ? '0 0' : '0' }}>
            <Survey
              settings={settings}
              preloader={preloader}
            />
          </Card>
        </Tabs.TabPane>
        {/* <Tabs.TabPane tab="Сводный отчет" key="free report">
          <ConsolidatedReport
            settings={settings}
            preloader={preloader}
            activeSection={activeSection}
          />
        </Tabs.TabPane> */}
        <Tabs.TabPane tab="Детализированный отчет" key="detailed">
          <Card style={{ margin: isMobile ? '0 0' : '0' }}>
            <DetailedReport
              settings={settings}
              preloader={preloader}
              activeSection={activeSection}
            />
          </Card>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Детализированный отчет (новый вид)" key="detailedNew">
          <Card style={{ margin: isMobile ? '0 0' : '0' }}>
            <DetailedReportNew
              settings={settings}
              preloader={preloader}
              activeSection={activeSection}
            />
          </Card>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Лояльность" key="nps">
          <Card style={{ margin: isMobile ? '0 0' : '0' }}>
            <NpsReport
              settings={settings}
              preloader={preloader}
              activeSection={activeSection}
            />
          </Card>
        </Tabs.TabPane>
      </Tabs>

    </ReportBigBox>
  );
}

export default QualityControl;
